interface SegmentMessage {
  name?: string;
  message: 'identify' | 'group' | 'track' | 'page';
  path: string;
  properties: Record<string, unknown>;
  title: string;
  url: string;
  userId: string;
}

export default class Client {
  private callQueue: Array<SegmentMessage> = [];
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private iframe: HTMLIFrameElement = null;
  private isIframeLoaded = false;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private userId: string = null;

  public sendSegmentPageEvent(name: string, properties: Record<string, unknown>) {
    this.processSegmentEvent({
      properties,
      name: name,
      message: 'page',
      path: location.pathname,
      title: document.title,
      // Omitting search parameters so we don't leak sensitive data to Segment.
      url: window.location.href.split('?')[0],
      userId: this.userId,
    });
  }

  public sendSegmentTrackEvent(
    eventOrProperties: string | Record<string, unknown>,
    properties?: Record<string, unknown>,
  ) {
    this.processSegmentEvent({
      properties: properties != null ? properties : (eventOrProperties as Record<string, unknown>),
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      name: typeof eventOrProperties === 'string' ? eventOrProperties : null,
      message: 'track',
      path: location.pathname,
      title: document.title,
      // Omitting search parameters so we don't leak sensitive data to Segment.
      url: window.location.href.split('?')[0],
      userId: this.userId,
    });
  }

  public sendSegmentGroupEvent(groupId: string, properties: Record<string, unknown>) {
    this.processSegmentEvent({
      properties,
      name: groupId,
      message: 'group',
      path: location.pathname,
      title: document.title,
      // Omitting search parameters so we don't leak sensitive data to Segment.
      url: window.location.href.split('?')[0],
      userId: this.userId,
    });
  }

  public sendSegmentIdentifyEvent(
    userIdOrProperties: string | Record<string, unknown>,
    properties?: Record<string, unknown>,
  ) {
    this.processSegmentEvent({
      properties: properties != null ? properties : (userIdOrProperties as Record<string, unknown>),
      message: 'identify',
      path: location.pathname,
      title: document.title,
      // Omitting search parameters so we don't leak sensitive data to Segment.
      url: window.location.href.split('?')[0],
      userId: typeof userIdOrProperties === 'string' ? userIdOrProperties : this.userId,
    });
  }

  public setIframe(iframe: HTMLIFrameElement) {
    this.iframe = iframe;
  }

  public setIsIframeLoaded(isIframeLoaded: boolean) {
    this.isIframeLoaded = isIframeLoaded;
  }

  public setUserId(userId: string) {
    this.userId = userId;
  }

  private processSegmentEvent(message: SegmentMessage) {
    this.callQueue.push(message);
    if (
      this.isIframeLoaded &&
      this.iframe?.contentWindow &&
      // Identify and group calls made from the login page are called during the transition from login to dashboard.
      // During this flow the iframe is in the middle of reloading. We delay sending the calls until after
      // the iframe has loaded again to avoid calls being sent to the older iframe and lost.
      !(location.pathname === '/dashboard/login' && ['identify', 'group'].includes(message.message))
    ) {
      this.flushQueue();
    }
  }

  private flushQueue() {
    while (this.callQueue.length) {
      const message = this.callQueue.shift();
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      this.iframe.contentWindow.postMessage(message, '*');
    }
  }
}

export const SegmentClient = new Client();
